import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/vipImg/icon_fail.png'


const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "auto-pay-disabled-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "auto-pay-disabled-content" }
const _hoisted_5 = { class: "flex-ter-cen" }

import { t } from '@/plugins/i18n'

import { useRtfix } from '@/store'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  beforehandVipInfo: {
    type: Object,
    default: () => { return {} }
  }
},
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props
const router = useRouter()





return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "auto-pay-disabled",
    "model-value": __props.visible,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('update:visible', false))),
    draggable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_unref(t)('支付失败')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('余额不足，请先充值余额后重试。')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(_unref(useRtfix)('CustomerFund')))),
          style: {"width":"100px","height":"36px"},
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('充值')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})